import React from "react";
import { styled } from "styled-components";

const BaseButton = styled.button`
    padding: 8px 20px;
    white-space: nowrap;
    transition: 100ms;
    display: inline-block;
    text-decoration: none;
`;

const ButtonRounded = styled(BaseButton)`
    border: 1px solid #F05A26;
    border-radius: 21px;
    background-color: #F05A26;
    color: #fff!important;
    font-size: 14px!important;
    font-weight: 700!important;
    &:hover {
        background-color: #ffffff;
        border-color: #F05A26;
        color: #F05A26!important;
    }
`;

const Button = ({ variant, children, as, href }) => {
    const renderButton = () => {
        switch (variant) {
            case "rounded":
                return <ButtonRounded as={as || ''} href={href || ''}>{children}</ButtonRounded>;
                break;

            default:
                return <BaseButton>{children}</BaseButton>;
                break;
        }
    };

    return renderButton();
};

export default Button;
